import gql from 'graphql-tag';
import { uploadPdf } from './uploadPdf';
import { uploadVideo } from './uploadVideo';
import { uploadImage } from './uploadImage';

export const updateEvidenceMutation = gql`
  mutation updateEvidence(
    $id: ID!
    $name: String
    $type: EvidenceType
    $status: Status
    $plotId: ID
    $content: String
    $pdf: String
    $fileName: String
    $uploadChoice: UploadChoice
    $videoEvidenceLoop: Int
  ) {
    data: updateEvidence(
      id: $id
      name: $name
      type: $type
      status: $status
      plotId: $plotId
      content: $content
      pdf: $pdf
      fileName: $fileName
      uploadChoice: $uploadChoice
      videoEvidenceLoop: $videoEvidenceLoop
    ) {
      id
      name
      type
      status
      content
      uploadChoice
      videoEvidenceLoop
      pdf{
        url
        fileName
      }
      plotId {
        id
        name
        status
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const updateEvidence = async ({ client, params }) => {
  // Parameter not picking up correctly, need to overwrite
  params.data.plotId = params.data.plotId.id;
  if (params.data.uploadChoice === 'EDITOR') {
    delete params.data.pdf;
  }
  if (params.data.uploadChoice === 'PDF') {
    if (params.data.pdf?.rawFile) {
      const response = await uploadPdf(client, params)
      params.data.pdf = response.accessUrl;
      params.data.fileName = response.fileName;
    } else {
      params.data.pdf = params.data.pdf.url;
      params.data.fileName = params.data.pdf.fileName;
    }
  } else if (params.data.uploadChoice === 'VIDEO') {
    console.log(params);
    
    if (params.data.video?.rawFile) {
      const response = await uploadVideo(client, params);
      params.data.pdf = response.accessUrl;
      params.data.fileName = response.fileName;
    } else {
      params.data.pdf = params.data.pdf.url;
      params.data.fileName = params.data.pdf.fileName;
    }
  } else if (params.data.uploadChoice === 'IMAGE') {
    if (params.data.image?.rawFile || params.data.pdf?.rawFile) {
      const response = await uploadImage(client, params);
      params.data.pdf = response.accessUrl;
      params.data.fileName = response.fileName;
    } else {
      const existingPdf = params.data.pdf;
      params.data.pdf = existingPdf?.url;
      params.data.fileName = existingPdf?.fileName;
    }
    delete params.data.image;
  }
  const result = await client.mutate({
    mutation: updateEvidenceMutation,
    variables: {
      ...params.data,
    },
  });

  return result.data;
};
